export enum LiveLectureStatusEnum {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  FULL = "FULL",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
